import { classNames } from "../../../ui/styles/classNames";
import { snippetParts } from "./snippetParts";

/** A search snippet with its matches highlighted, rendered as text. */
export default function HighlightedSnippet({ snippet, className }: { snippet: string; className?: string }) {
  return (
    <span className={classNames("app-text-muted block text-xs", className)}>
      {snippetParts(snippet).map((part, index) => part.match
        ? <mark key={index} className="rounded-sm bg-amber-100 px-0.5 text-black">{part.text}</mark>
        : <span key={index}>{part.text}</span>)}
    </span>
  );
}
